import mapProps from 'recompose/mapProps';

const withCanvasPrimary = mapProps(({ primary, ...props }) => ({
  ...props,
  primary: {
    ...primary.embedCanvasPages.canvas,
    productId: primary.embedCanvasPages.main.productId,
    drawers: {
      form: primary.embedCanvasPages.form,
      other: primary.embedCanvasPages.canvas.body,
    },
  },
}));

export default withCanvasPrimary;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Canvas/withCanvasPrimary.js